import React from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";

const UploadStatisticsChart = ({ data }) => (
  <div className="chart-block p-3 p-md-4" style={{ minHeight: "350px", height: "100%" }}>
    <p className="mb-4"><strong>Upload statistics</strong></p>
    <div className="my-md-5 px-md-4" style={{ width: "100%", height: "260px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 5, right: 30, left: 5, bottom: 5 }}>
          <XAxis dataKey="date" stroke="#d3d6d8" style={{ fontSize: "0.7rem", fontFamily: "Inter" }} />
          <YAxis stroke="#d3d6d8" label={{ value: "Number of resources", angle: -90, offset: 0, position: "insideLeft" }} style={{ fontSize: "0.7rem", fontFamily: "Inter" }} />
          <Tooltip cursor={{ fill: "#e2e3e5" }}/>
          <Legend verticalAlign="top" height={42}/>
          <Bar dataKey="Active" fill="#00C49F" barSize={5}/>
          <Bar dataKey="Deleted" fill="#e35d6a" barSize={5}/>
          <Bar dataKey="Total" fill="#0088FE" barSize={5}/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default UploadStatisticsChart;
